import { Box, LinearProgress, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";

interface RefetchIndicatorProps {
  visible: boolean;
  /** When visible is set to false, the element will disappear after this amount in ms. Default 500ms. */
  disappearDelayMs?: number;
}

export const RefetchIndicator: React.FC<RefetchIndicatorProps> = ({ visible, disappearDelayMs = 500 }) => {
  const [render, setRender] = useState(false);

  useEffect(() => {
    if (!visible) {
      setTimeout(() => {
        setRender(false);
      }, disappearDelayMs);
    } else {
      setRender(true);
    }
  }, [visible, disappearDelayMs]);

  if (!render) return <></>;

  return (
    <Box
      position="fixed"
      left={0}
      right={0}
      bottom={5}
      margin={"auto"}
      sx={{ zIndex: 10, maxWidth: 400, width: "55vw", transition: "all .2s" }}
    >
      <Paper elevation={2}>
        <LinearProgress color="primary" />
        <Box sx={{ textTransform: "uppercase", fontWeight: "bold", textAlign: "center" }}>Refreshing Page Data</Box>
      </Paper>
    </Box>
  );
};

export default RefetchIndicator;
